angular.module('directives.dashboard').controller('wgtSettingsTimePeriod',
['$scope', '$rootScope',
    function ($scope, $rootScope) {
        if ($scope.item.setting === undefined) {
            $scope.selectedSettingItem = {
                locationIds : null,
                selectedWidgetTimeFrame: "0"
            };
        } else {
            if(angular.isString($scope.item.setting)){
                $scope.item.setting = JSON.parse($scope.item.setting);
            }

            $scope.selectedSettingItem = {
                locationIds : $scope.item.setting.locationIds[0],
                selectedWidgetTimeFrame: $scope.item.setting.selectedWidgetTimeFrame !== undefined ? $scope.item.setting.selectedWidgetTimeFrame.toString(): "0"
            }
        }
        $scope.saveSettings = function () {
            if ($scope.selectedSettingItem.locationIds === null || $scope.selectedSettingItem.locationIds === undefined || $scope.selectedSettingItem.locationIds === 0) {
                $scope.$parent.selectedLocation = '';
                $scope.$parent.selectedLocationNumber = '';
                $scope.$parent.selectedLocationId = 0;
                $scope.$parent.selectedWidgetTimeFrame = $scope.selectedSettingItem.selectedWidgetTimeFrame ? parseInt($scope.selectedSettingItem.selectedWidgetTimeFrame) : 0;
            } else {
                var location = $.grep($scope.currentUser.locations, function (e) {
                    return e.id === $scope.selectedSettingItem.locationIds;
                })[0];
                $scope.$parent.selectedLocation = location.locationName;
                $scope.$parent.selectedLocationNumber = location.locationNumber;
                $scope.$parent.selectedLocationId = location.id;
                $scope.$parent.selectedWidgetTimeFrame = parseInt($scope.selectedSettingItem.selectedWidgetTimeFrame)
            }
            $scope.selectedSettingItem = {locationIds: [$scope.$parent.selectedLocationId], selectedWidgetTimeFrame: parseInt($scope.$parent.selectedWidgetTimeFrame)};
            $scope.item.setting = $scope.selectedSettingItem;
            if ($scope.$parent) {
                if ($scope.$parent.loadWidget) {
                    $scope.$parent.loadWidget();
                }
            }
            $rootScope.$emit("widget.changed", $scope.item);

            $scope.$close();
        };
    }]);
